import config from "@/config";
var GameplayWorldWalls = /** @class */ (function () {
    function GameplayWorldWalls() {
    }
    GameplayWorldWalls.getInstance = function () {
        if (!this._instance) {
            this._instance = new GameplayWorldWalls();
        }
        return this._instance;
    };
    GameplayWorldWalls.prototype.load = function (scene) {
        this.scene = scene;
        return this;
    };
    GameplayWorldWalls.prototype.init = function () {
        // dimensions
        var cornerSize = {
            width: 128,
            height: 128,
        };
        var tileableSize = {
            width: 300,
            height: 87,
        };
        var cornerScale = {
            x: cornerSize.width / 400,
            y: cornerSize.height / 412,
        };
        var tileableScale = {
            x: tileableSize.width / 1312,
            y: tileableSize.height / 280,
        };
        var boundary = config.world.dimension.boundary;
        var wallCount = {
            horizontal: (boundary.width - cornerSize.width * 2) / tileableSize.width + 1,
            vertical: (boundary.height - cornerSize.height * 2) / tileableSize.width + 1,
        };
        // visuals
        var walls = this.scene.add.group();
        // top walls
        for (var i = 0; i < wallCount.horizontal; i++) {
            walls.add(this.scene.add
                .image(i * 284, -10, "wall.tileable")
                .setScale(tileableScale.x, tileableScale.y)
                .setOrigin(0, 1));
        }
        // bottom walls
        for (var i = 0; i < wallCount.horizontal; i++) {
            walls.add(this.scene.add
                .image(i * 284, boundary.height + 113, "wall.tileable")
                .setScale(tileableScale.x, tileableScale.y)
                .setOrigin(0, 1));
        }
        // left walls
        for (var i = 0; i < wallCount.vertical; i++) {
            walls.add(this.scene.add
                .image(-97, 16 + i * 284, "wall.tileable")
                .setScale(tileableScale.x, tileableScale.y)
                .setOrigin(0, 1)
                .setAngle(90));
        }
        // right walls
        for (var i = 0; i < wallCount.vertical; i++) {
            walls.add(this.scene.add
                .image(boundary.width + 25, 16 + i * 284, "wall.tileable")
                .setScale(tileableScale.x, tileableScale.y)
                .setOrigin(0, 1)
                .setAngle(90));
        }
        // top-left corner
        walls.add(this.scene.add
            .image(-32, -32, "wall.corner")
            .setScale(cornerScale.x, cornerScale.y)
            .setAngle(270));
        // top-right corner
        walls.add(this.scene.add
            .image(boundary.width + 48, -32, "wall.corner")
            .setScale(cornerScale.x, cornerScale.y)
            .setAngle(0));
        // bottom-left corner
        walls.add(this.scene.add
            .image(-32, boundary.height + 48, "wall.corner")
            .setScale(cornerScale.x, cornerScale.y)
            .setAngle(180));
        // bottom-right corner
        walls.add(this.scene.add
            .image(boundary.width + 48, boundary.height + 48, "wall.corner")
            .setScale(cornerScale.x, cornerScale.y)
            .setAngle(90));
    };
    return GameplayWorldWalls;
}());
export default GameplayWorldWalls;
